import baseService from "@common/services/base.service";
import store from "@common/store/store";
import sessionUtil from "@common/helpers/sessionStorage.utils";
const tributarioRoute = window.api_routes.smarAPD_Tributario_Domain;
const commonRoute = window.api_routes.smarAPD_Common;

let isExterno = sessionUtil.getItem("isExterno");

let http = baseService(store);

let controller = isExterno ? 'CepExterno' : 'Cep';

const apidDef = {
  getByCep({ data, reference }) {
    return http.get(`${tributarioRoute}/${controller}/GetByCep/${data}`, {
      params: {
        reference: reference
      }
    });
  },
  getByCepPorCidade({ data, reference }) {
    return http.get(`${tributarioRoute}/${controller}/GetByCepPorCidade/${data}`, {
      params: {
        reference: reference
      }
    });
  },
  cidadeSuggestion(busca, parameters) {
    return http.get(`${tributarioRoute}/${controller}/getbycidadesuggestion`, {
      params: {
        busca: busca,
        uf: parameters.Uf
      },
      noLoading: true
    });
  },
  tipoSuggestion(busca) {
    return http.get(`${tributarioRoute}/${controller}/getbytiposuggestion`, {
      params: {
        busca: busca
      },
      noLoading: true
    });
  },
  logradouroSuggestion(busca, parameters) {
    return http.get(`${tributarioRoute}/${controller}/getbylogradourosuggestion`, {
      params: {
        busca: busca,
        cep: parameters.Cep,
        cidade: parameters.Cidade,
        bairro: parameters.Bairro,
        uf: parameters.Uf,
      },
      noLoading: true
    });
  },
  bairroSuggestion(busca, parameters) {
    return http.get(`${tributarioRoute}/${controller}/getbybairrosuggestion`, {
      params: {
        busca: busca,
        cidade: parameters.Cidade,
        uf: parameters.Uf,
        logradouro: parameters.Logradouro
      },
      noLoading: true
    });
  },
  filterAddressCommonLookup(data,headers){
    return http.post(`${commonRoute}/DadosComuns/filter`, data, headers);
  },
  filterAddressLookup(data,headers){
    return http.post(`${tributarioRoute}/${controller}/lookup`, data, headers);
  },

};

export default apidDef;
